export enum apiUrlBusiness {
    GET_BUSINESSES = '/v1/businesses/',
    BUSINESS_LIST = 'v1/business-list/',
    EVENT_LEVEL2_DETAILS = '/v1/events-level2-details',
    USER_STATUS = '/v1/user-status/',
}
